import styled from 'styled-components';

import Tooltip, { HelpUnderline } from '#/components/shared/Tooltip';
import Description from '#/components/perpetuals/Description';
import Mono from '#/components/shared/Mono';
import ValueChange from '#/components/shared/ValueChange';

import { useAccountSummaryView } from '#/features/account/account-summary-context';

import useUserStorageKey from '#/utils/useUserStorageKey';
import useLocalStorage from '#/utils/useLocalStorage';

import DescriptionList from './DescriptionList';

export default function AccountSummary() {
  const view = useAccountSummaryView();

  const [isExpanded, setExpanded] = useLocalStorage(
    useUserStorageKey('futures-account-summary-expanded'),
    true,
  );

  const onToggle = () => setExpanded((prevExpanded) => !prevExpanded);

  return (
    <DescriptionList
      collapsible
      title="Account"
      expanded={isExpanded}
      onToggle={onToggle}
    >
      <Description
        label={
          <Tooltip label="The total value of your account at current mark prices">
            <HelpUnderline>Account Value</HelpUnderline>
          </Tooltip>
        }
        value={<Value>{view.accountValue}</Value>}
      />

      <Description
        label="Unrealized P&L"
        value={
          <ValueChange direction={view.unrealizedPnlDirection}>
            {view.unrealizedPnl}
          </ValueChange>
        }
      />

      <Description
        label="Free Collateral"
        value={<Value>{view.freeCollateral}</Value>}
      />
      <Description
        label="Account Leverage"
        value={<Value>{view.leverage}</Value>}
      />
    </DescriptionList>
  );
}

const Value = styled(Mono)`
  font-size: 11px;
`;
